import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
   ListItemButton,
  Link,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack
} from '@mui/material';

import {
  Layers,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données hiérarchisées
const populationData = {
  title: "Effectif de la population résidente par province et commune selon le sexe",
  provinces: [
    {
      name: "BUHUMUZA",
      communes: [
        { name: "BUTAGANZWA", masculin: "52 629", feminin: "57 184", total: "109 813", proportion: "0,9" },
        { name: "BUTIHINDA", masculin: "207 178", feminin: "226 988", total: "434 166", proportion: "3,5" },
        { name: "CANKUZO", masculin: "78 438", feminin: "82 849", total: "161 287", proportion: "1,3" },
        { name: "GISAGARA", masculin: "139 923", feminin: "151 475", total: "291 398", proportion: "2,4" },
        { name: "GISURU", masculin: "162 122", feminin: "175 527", total: "337 649", proportion: "2,7" },
        { name: "MUYINGA", masculin: "237 315", feminin: "258 612", total: "495 927", proportion: "4,0" },
        { name: "RUYIGI", masculin: "108 004", feminin: "114 017", total: "222 021", proportion: "1,8" }
      ],
      masculin: "985 609",
      feminin: "1 066 652",
      total: "2 052 261",
      proportion: "16,6"
    },
    {
      name: "BUJUMBURA",
      communes: [
        { name: "BUBANZA", masculin: "117 952", feminin: "125 026", total: "242 978", proportion: "2,0" },
        { name: "BUKINANYANA", masculin: "130 834", feminin: "138 713", total: "269 547", proportion: "2,2" },
        { name: "CIBITOKE", masculin: "127 680", feminin: "133 096", total: "260 776", proportion: "2,1" },
        { name: "ISARE", masculin: "70 357", feminin: "78 916", total: "149 273", proportion: "1,2" },
        { name: "MPANDA", masculin: "179 666", feminin: "182 595", total: "362 261", proportion: "2,9" },
        { name: "MUGERE", masculin: "250 294", feminin: "262 587", total: "512 881", proportion: "4,2" },
        { name: "MUGINA", masculin: "109 909", feminin: "115 375", total: "225 284", proportion: "1,8" },
        { name: "MUHUTA", masculin: "55 372", feminin: "61 689", total: "117 061", proportion: "0,9" },
        { name: "MUKAZA", masculin: "96 895", feminin: "71 934", total: "168 829", proportion: "1,4" },
        { name: "NTAHANGWA", masculin: "475 466", feminin: "452 441", total: "927 907", proportion: "7,5" },
        { name: "RWIBAGA", masculin: "54 537", feminin: "62 221", total: "116 758", proportion: "0,9" }
      ],
      masculin: "1 668 962",
      feminin: "1 684 593",
      total: "3 353 555",
      proportion: "27,2"
    },
    {
      name: "BURUNGA",
      communes: [
        { name: "BURURI", masculin: "90 393", feminin: "99 565", total: "189 958", proportion: "1,5" },
        { name: "MAKAMBA", masculin: "175 272", feminin: "195 365", total: "370 637", proportion: "3,0" },
        { name: "MATANA", masculin: "93 639", feminin: "101 630", total: "195 269", proportion: "1,6" },
        { name: "MUSONGATI", masculin: "161 159", feminin: "175 188", total: "336 347", proportion: "2,7" },
        { name: "NYANZA", masculin: "179 952", feminin: "189 717", total: "369 669", proportion: "3,0" },
        { name: "RUMONGE", masculin: "206 626", feminin: "222 611", total: "429 237", proportion: "3,5" },
        { name: "RUTANA", masculin: "109 813", feminin: "117 621", total: "227 434", proportion: "1,8" }
      ],
      masculin: "1 016 854",
      feminin: "1 101 697",
      total: "2 118 551",
      proportion: "17,2"
    },
    {
      name: "BUTANYERERA",
      communes: [
        { name: "BUSONI", masculin: "170 335", feminin: "187 656", total: "357 991", proportion: "2,9" },
        { name: "KAYANZA", masculin: "157 441", feminin: "174 992", total: "332 433", proportion: "2,7" },
        { name: "KIREMBA", masculin: "137 799", feminin: "154 228", total: "292 027", proportion: "2,4" },
        { name: "KIRUNDO", masculin: "228 361", feminin: "250 131", total: "478 492", proportion: "3,9" },
        { name: "MATONGO", masculin: "121 775", feminin: "144 125", total: "265 900", proportion: "2,2" },
        { name: "MUHANGA", masculin: "99 687", feminin: "123 104", total: "222 791", proportion: "1,8" },
        { name: "NGOZI", masculin: "151 651", feminin: "165 157", total: "316 808", proportion: "2,6" },
        { name: "TANGARA", masculin: "121 687", feminin: "142 077", total: "263 764", proportion: "2,1" }
      ],
      masculin: "1 188 736",
      feminin: "1 341 470",
      total: "2 530 206",
      proportion: "20,5"
    },
    {
      name: "GITEGA",
      communes: [
        { name: "BUGENDANA", masculin: "102 918", feminin: "126 734", total: "229 652", proportion: "1,9" },
        { name: "GISHUBI", masculin: "101 610", feminin: "141 923", total: "243 533", proportion: "2,0" },
        { name: "GITEGA", masculin: "244 171", feminin: "284 357", total: "528 528", proportion: "4,3" },
        { name: "KARUSI", masculin: "177 778", feminin: "199 860", total: "377 638", proportion: "3,1" },
        { name: "KIGANDA", masculin: "68 276", feminin: "81 246", total: "149 522", proportion: "1,2" },
        { name: "MURAMVYA", masculin: "79 435", feminin: "91 575", total: "171 010", proportion: "1,4" },
        { name: "MWARO", masculin: "70 429", feminin: "78 761", total: "149 190", proportion: "1,2" },
        { name: "NYABIHANGA", masculin: "78 711", feminin: "96 497", total: "175 208", proportion: "1,4" },
        { name: "SHOMBO", masculin: "117 580", feminin: "136 354", total: "253 934", proportion: "2,1" }
      ],
      masculin: "1 040 908",
      feminin: "1 237 307",
      total: "2 278 215",
      proportion: "18,5"
    }
  ],
  total: {
    masculin: "5 901 069",
    feminin: "6 431 719",
    total: "12 332 788",
    proportion: "100,0"
  }
};

const PopulationDataPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };
  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };
const filteredProvinces = populationData.provinces.map(province => {
    if (!searchTerm) return province;
    const filteredCommunes = province.communes.filter(commune =>
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return {
      ...province,
      communes: filteredCommunes,
      show: filteredCommunes.length > 0 || 
            province.name.toLowerCase().includes(searchTerm.toLowerCase())
    };
  }).filter(province => province.show || !searchTerm);

 // Calcul des indicateurs clés
const keyStats = {
  totalPopulation: populationData.total.total,
  womenPercentage: (
    (parseFloat(populationData.total.feminin.replace(/\s/g, '')) / 
     parseFloat(populationData.total.total.replace(/\s/g, ''))) * 100
  ).toFixed(1),
  
  mostPopulousProvince: populationData.provinces.reduce((max, province) => 
    parseFloat(province.total.replace(/\s/g, '')) > parseFloat(max.total.replace(/\s/g, '')) ? province : max
  ),

  leastPopulousProvince: populationData.provinces.reduce((min, province) => 
    parseFloat(province.total.replace(/\s/g, '')) < parseFloat(min.total.replace(/\s/g, '')) ? province : min
  ),

  highestWomenPercentage: populationData.provinces.reduce((max, province) => {
    const womenPct = (
      parseFloat(province.feminin.replace(/\s/g, '')) / 
      parseFloat(province.total.replace(/\s/g, ''))
    ) * 100;
    return womenPct > max.womenPct ? { province, womenPct } : max;
  }, { province: null, womenPct: 0 })
};


  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );


  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h5" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {populationData.title}
                    </Typography>
                  </Box>
                    <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                         <Grid item xs={12} sm={6} md={6} ></Grid>
                         <Grid item xs={12} sm={6} md={6}>
                   <TextField
                      size="small"
                      placeholder="Rechercher province/commune..."
                      variant="outlined"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: { xs: '100%', sm: '480px' } }}
                    />
                    </Grid>
                    </Grid>
                  
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés par Province
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Totale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {populationData.total.total}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Proportion Femmes
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.womenPercentage}%
                              </Typography>
                              <Typography variant="caption">
                                Moyenne nationale
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Province la plus peuplée
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulousProvince.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulousProvince.total}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({keyStats.mostPopulousProvince.proportion}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus forte proportion femmes
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.highestWomenPercentage.province.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.highestWomenPercentage.womenPct.toFixed(1)}%
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Proportion (%)</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.masculin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.feminin}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.total}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{populationData.total.proportion}</TableCell>
                        </ProvinceRow>

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.name)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{province.masculin}</TableCell>
                              <TableCell align="right">{province.feminin}</TableCell>
                              <TableCell align="right">{province.total}</TableCell>
                              <TableCell align="right">{province.proportion}</TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={5}>
                                <Collapse in={expandedProvinces[province.name] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune, idx) => (
                                        <CommuneRow key={idx} hover>
                                          <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                          <TableCell align="right">{commune.masculin}</TableCell>
                                          <TableCell align="right">{commune.feminin}</TableCell>
                                          <TableCell align="right">{commune.total}</TableCell>
                                          <TableCell align="right">{commune.proportion}</TableCell>
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                       {/*
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                 */}

                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative du Burundi
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Le Burundi est divisé en 5 provinces administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="1. BUHUMUZA" 
                          secondary="Communes: BUTAGANZWA, BUTIHINDA, CANKUZO, GISAGARA, GISURU, MUYINGA, RUYIGI" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="2. BUJUMBURA" 
                          secondary="Communes: BUBANZA, BUKINANYANA, CIBITOKE, ISARE, MPANDA, MUGERE, MUGINA, MUHUTA, MUKAZA, NTAHANGWA, RWIBAGA" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="3. BURUNGA" 
                          secondary="Communes: BURURI, MAKAMBA, MATANA, MUSONGATI, NYANZA, RUMONGE, RUTANA" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="4. BUTANYERERA" 
                          secondary="Communes: BUSONI, KAYANZA, KIREMBA, KIRUNDO, MATONGO, MUHANGA, NGOZI, TANGARA" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="5. GITEGA" 
                          secondary="Communes: BUGENDANA, GISHUBI, GITEGA, KARUSI, KIGANDA, MURAMVYA, MWARO, NYABIHANGA, SHOMBO" 
                        />
                      </ListItem>
                    </List>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et de l'Elevage (RGPHAE) 
                    réalisé en 2024. Les chiffres incluent la population des ménages ordinaires, ménages collectifs et sans-abris.
                    Les proportions sont calculées par rapport à la population totale du Burundi.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      
      {/* Pied de page */}
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPage;